import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function LatestSection() {
  const latest = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              最新更新
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              每周更新的雏田同人创作内容，精彩不容错过
            </p>
          </div>
          <Link
            to="/category/tongren-manhua"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
              data-product-shop=""
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.hot && (
                  <span className="absolute top-3 right-3 bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap">
                    热门
                  </span>
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i>
                    {article.likes.toLocaleString()}
                  </span>
                  <span className="text-foreground-300">by {article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/tongren-manhua"
            className="inline-flex items-center gap-2 px-8 py-3 bg-secondary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览更多作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}